import { renderHomeView } from './views/homeView.js';
import { renderPublicJarView } from './views/publicJarView.js';

const RESERVED = new Set(['']);

export function createRouter(root: HTMLElement) {
  async function render(): Promise<void> {
    const path = window.location.pathname.replace(/\/+$/, '');
    if (!path) {
      await renderHomeView(root);
      return;
    }
    const jarName = path.slice(1).toLowerCase();
    if (RESERVED.has(jarName)) {
      await renderHomeView(root);
      return;
    }
    await renderPublicJarView(root, jarName);
  }

  return {
    start() {
      window.addEventListener('popstate', () => {
        void render();
      });
      void render();
    },
  };
}
